import { addDoc, collection, doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { firestore } from '../lib/firebase';

const leadsCollection = collection(firestore, 'default');

export type LeadStatus = 'new' | 'in_progress' | 'done';

export interface LeadPayload {
  name: string;
  email: string;
  role: string;
  ordine?: string;
  school: string;
  location?: string;
  phone?: string;
  size?: string;
  interests: string[];
  interestLabels: string[];
  message?: string;
  consentPrivacy: boolean;
  consentMarketing: boolean;
  locale: string;
  status?: LeadStatus;
  processedBy?: string;
  processedAt?: Date;
  notes?: string;
}

export const createLead = async (payload: LeadPayload) => {
  await addDoc(leadsCollection, {
    ...payload,
    status: 'new',
    createdAt: serverTimestamp(),
  });
};

export const updateLeadStatus = async (
  leadId: string,
  status: LeadStatus,
  processedBy: string,
  notes?: string
) => {
  const leadRef = doc(leadsCollection, leadId);
  await updateDoc(leadRef, {
    status,
    processedBy,
    processedAt: serverTimestamp(),
    ...(notes !== undefined && { notes }),
  });
};
